import { createElement } from "react"

export function GlobalQueryLoadingBar({
  visible,
  label,
}: {
  visible: boolean
  label: string
}) {
  if (!visible) return null

  return createElement(
    "div",
    {
      role: "progressbar",
      "aria-label": label,
      "aria-valuetext": label,
      className: "global-query-loading-indicator pointer-events-none fixed inset-x-0 top-0 z-[10000] h-[3px] overflow-hidden bg-primary/15",
    },
    createElement("div", {
      className: "global-query-loading-indicator__bar h-full bg-primary",
    }),
  )
}
